export const logError = message => {
    console.error(message);
}



// WEBPACK FOOTER //
// ./src/shared/utils/logger.js